import { CustomerQueryParams, OrderQueryParams, QueryParamDataType, SettingsQueryParams, WorkspaceSettingsViews } from '../constants';

const CustomersPageQueryParams = {
  [OrderQueryParams.ORDER]: {
    required: false,
    type: QueryParamDataType.UUID,
  },
  [CustomerQueryParams.PAGE]: {
    required: false,
    type: QueryParamDataType.NUMBER,
  },
  [CustomerQueryParams.CUSTOMER_PROFILE]: {
    required: false,
    type: QueryParamDataType.STRING,
  },
  [SettingsQueryParams.SETTINGS]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: WorkspaceSettingsViews,
  },
};

export default CustomersPageQueryParams;
